export default __webpack_public_path__ + "static/char-s-53-en-79dc7a2c27d25fca44d8d08c0b1d713f.png";